import * as React from 'react';
import { Flex, FlexItem } from './compositeComponents/FlexHelpers';
import { H1 } from './typography/Heading';
import { Divider } from './Divider';
import { DarkLink } from './Link';
import { Icon, iconName } from './icons/Icons';
import { Small } from './typography/Body';

export type PageHeaderProps = {
    headerIcon?:iconName,
    headerText?:string,
    subHeader?:{ icon?:iconName, iconColor?:string, text:string },
    headerContentsOverride?:React.ReactNode,
    headerStyle:'primary-black' | 'secondary-gray',
    buttons?:React.ReactNode,
    breadCrumbs?:{text:string, url:string, leadingIcon?:iconName}[]
}
export function PageHeader(props:PageHeaderProps):JSX.Element
{
    let headerText:React.ReactNode = 
        <H1 color={props.headerStyle==='primary-black' ? 'black' : 'gray'}>
            {props.headerText ||''}
        </H1>;
        
    if(props.headerContentsOverride)
    {
        headerText = props.headerContentsOverride
    }

    return (
        <Flex flexDirection="column" gap={4}>

            <Flex flexDirection="row" justifyContent='space-between' alignItems='flex-end'>
                <Flex flexDirection='row' gap={16} alignItems='center'>
                    
                    <Flex flexDirection='column' gap={4} alignItems='flex-start'>

                        <Flex flexDirection='row' gap={8} alignItems='center'>
                            {props.headerIcon &&
                                <Icon name={props.headerIcon} size="medium" />
                            }
                            {headerText}
                        </Flex>
                    
                        {props.subHeader && 
                            <Flex gap={8} style={{paddingLeft:'8px'}}>
                                {props.subHeader.icon &&
                                    <Icon name={props.subHeader.icon} size="x-small" color={props.subHeader.iconColor} />
                                }
                                <Small>{props.subHeader.text}</Small>
                            </Flex>
                        }
                    </Flex>

                </Flex>
                <FlexItem>
                    {props.buttons}
                </FlexItem>
            </Flex>

            <Divider />
            
            {props.breadCrumbs && props.breadCrumbs.length > 0 &&
                <Flex alignItems='center'>
                    {props.breadCrumbs.map((crumb, index) =>
                        <Flex key={index}>
                            {index > 0 &&
                                <span style={{padding:'0 5px'}}>/</span>
                            }
                            <DarkLink href={crumb.url} style={{display:'flex', alignItems:'center', gap:'4px'}}>
                                {crumb.leadingIcon && <Icon name={crumb.leadingIcon} size="x-small" />}
                                {crumb.text}
                            </DarkLink>
                        </Flex>
                    )}
                </Flex>
            }

        </Flex>
    );
}